import React from 'react';
import { Col, ListGroup, ListGroupItem } from 'react-bootstrap';

export function FeaturesPage() {
  return (
    <Col>
      <h1> Upcoming Features </h1>
      <ListGroup>
        <ListGroupItem> add new fields to the item (cost, expiration, etc.)</ListGroupItem>
        <ListGroupItem> Transactions records and sell button </ListGroupItem>
        <ListGroupItem> Barcode scanner </ListGroupItem>
        <ListGroupItem> GenAI features for dashboards </ListGroupItem>
      </ListGroup>
    </Col>
  );
}